
export function groupNodes(originalNodes, groupName) {
    const groupNode = {
        type: 'group',
        value: groupName,
        visjsProps: {
            mass: 1
        }
    };
    const nodes = [groupNode], edges = [];

    for (let originalNode of originalNodes) {
        const node = {
            type: originalNode.type,
            value: originalNode.value
        };

        const edge = {
            from_type: groupNode.type,
            from_value: groupNode.value,
            to_type: node.type,
            to_value: node.value,
            visjsProps: {
                arrows: '',
                length: 1,
            },
            info: [{
                label: 'grouped',
                source: 'added_by_user',
                comment: `${node.type} / ${node.value} was marked as part of group '${groupName}'`,
                timestamp: -1
            }]
        }
        edges.push(edge);
    }

    return {nodes, edges};
}
